export default "__VITE_ASSET__9d05ce47__"